import { Box, Checkbox, FormControlLabel, SxProps, Theme } from "@mui/material";
import WorkItemTextInput from "../shared/WorkItemTextInput";
import { BulkUpdateModes } from "../WorkItemBulkUpdate";

interface IWorkItemSearchFieldWorkItemProps {
    idSuffix: string,
    canIncludeChilren: boolean,
    labelProps?: SxProps<Theme> | undefined,
    onChange: (e: any) => void
    onChangeCheckbox?: () => void
}

const WorkItemSearchFieldWorkItem = (props: IWorkItemSearchFieldWorkItemProps) => {
    return (
        <>
            <Box>
                <WorkItemTextInput 
                    label="Work Item" 
                    labelProps={props.labelProps}
                    idSuffix={props.idSuffix}
                    onChange={e => props.onChange(e)}/>
            </Box>
            {props.canIncludeChilren && <Box sx={{paddingLeft: '8px'}}>
                <FormControlLabel 
                    id={"search-include-children-"+props.idSuffix}
                    onChange={props.onChangeCheckbox} 
                    control={<Checkbox defaultChecked />} 
                    label="Include children" />
            </Box>}
        </>
    );
}


export default WorkItemSearchFieldWorkItem;